import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const AircraftCreate = (props) => {
    return (
            <CreateGuesser {...props}/>
    );
};

export default AircraftCreate;
